import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.storySlider = function() {
    return {
        swiper: null,

        init() {
            this.$nextTick(() => {
                this.initSwiper();
            });

            // Listen for Livewire updates
            Livewire.hook('morph.updated', () => {
                this.handleLivewireUpdate();
            });
        },

        initSwiper() {
            const swiperElement = this.$el.querySelector('.story-list-swiper');
            const nextButton = this.$el.querySelector('.swiper-button-next');

            if (!swiperElement || !nextButton) {
                return;
            }

            // Destroy existing swiper if it exists
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            // Initialize new Swiper
            this.swiper = new Swiper(swiperElement, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: nextButton,
                },
                // Only enable on mobile
                breakpoints: {
                    768: {
                        enabled: false,
                    }
                }
            });
        },

        handleLivewireUpdate() {
            // Wait for DOM to update, then reinitialize
            this.$nextTick(() => {
                setTimeout(() => {
                    this.initSwiper();
                }, 100);
            });
        }
    }
};
